/*
PLEASE USE THE SAMPLE BANNER BLOCK PROVIDED BELOW:

{
    collection: [],
    queries: [],
    link: '',
    bannerImage: '',
    bannerPosition: 1
},

*/ 
document.addEventListener('Searchanise.Loaded', function () {
    (function ($) {
        function snizeAddCollectionBanner(snizeColUrl, snizeBannerUrl, snizeBannerPosition, snizeCurrentUrl, snizeCurrentQuery) {
            if (location.pathname.includes('/pages/search-results-page') && snizeCurrentQuery.length) {
                let urlParams = new URLSearchParams(window.location.search);
                let paramsQuery = urlParams.get('q');
                for (let query of snizeCurrentQuery) {
                    if (paramsQuery == query) {
                        $(`ul.snize-search-results-content li:nth-child(${snizeBannerPosition})`).before(`
                            <li class="snize-banner snize-custom-banner"><a href=${snizeColUrl} target="_blank"><img src=${snizeBannerUrl}></a></li>`
                        );
                        break;
                    }
                }
            } else if (!location.pathname.includes('/pages/search-results-page') && snizeCurrentUrl.length) {
                for (let url of snizeCurrentUrl) {
                    if ($(location).attr('href').includes(url)) {
                        $(`ul.snize-search-results-content li:nth-child(${snizeBannerPosition})`).before(`
                            <li class="snize-banner snize-custom-banner"><a href=${snizeColUrl} target="_blank"><img src=${snizeBannerUrl}></a></li>`
                        );
                        break;
                    }
                }
            }
        }

        let snizeBannersDataEn = [
            {
                //collection where banner is using  
                collection: ['https://vivierskin.com/collections/anti-aging', '/collections/our-products', '/collections/fan-favourites', '/collections/all'],
                //search queries for which to display the banner
                queries: ['Anti aging', 'antiaging', 'Serum', 'Moisturizer'],
                //link for redirect after clicking
                link: 'https://www.vivierskin.com/collections/serums',
                //link to the banner image
                bannerImage: 'https://cdn.shopify.com/s/files/1/0072/7387/3453/files/Serum_Promo_Searchanise_Collection_Card.png?v=1743787598',
                //banner position
                bannerPosition: 6
            },
            {
                collection: ['https://vivierskin.com/collections/anti-aging', '/collections/fan-favourites', '/collections/all', '/collections/vitamin-c'],
                queries: ['Serum', 'Quiz', 'Anti aging', 'C E Peptides', 'Radiance'],
                link: 'https://vivierskin.com/pages/serum-quiz',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0072/7387/3453/files/Searchanise_Serum_Quiz_ENG.png?v=1743445461',
                bannerPosition: 10
            },
        ];
  
        $(document).on('Searchanise.ResultsUpdated', function () {
                    console.log('upd')

            let snizeBannersData = Shopify.locale == 'en' ? snizeBannersDataEn : snizeBannersDataFr;
            if (!$('.snize-custom-banner').length) {
                snizeBannersData.forEach(function (bannerData) {
                    snizeAddCollectionBanner(bannerData.link, bannerData.bannerImage, bannerData.bannerPosition, bannerData.collection, bannerData.queries);
                });
            }
        });
    })(window.Searchanise.$);
});